import { render } from "./VtoBackButton.vue?vue&type=template&id=3b7ee4ba"
import script from "./VtoBackButton.vue?vue&type=script&lang=js"
export * from "./VtoBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__